import React, { useEffect, useMemo } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import { observer } from 'mobx-react-lite';
import { useHistory, useParams } from 'react-router-dom';
import {
  ChecklistPageStore,
  ChecklistPageStoreContext,
  useChecklistPageStore,
} from 'store/pages/enrollment/checklist/pageStore';
import OptionList from 'components/common/checklist/OptionList';
import ChecklistOptionHeader from 'components/common/headers/ChecklistOptionHeader';
import { PageWrapper } from 'components/common/checklist/PageWrapper';

const PageHeader: React.FC = observer(() => {
  const { loadInitialData, goBackUrl } = useChecklistPageStore();

  const { periodId } = useParams<{ periodId: string }>();

  useEffect(() => {
    void loadInitialData(periodId);
  }, []);

  const history = useHistory();

  function returnBack(): void {
    history.push(goBackUrl || '');
  }

  return (
    <ChecklistOptionHeader
      title="Enrollment Checklist"
      subtitle="Step by step guided wizard for group setup and enrollment"
      backButtonFunc={goBackUrl ? returnBack : undefined}
    />
  );
});

const PageBody: React.FC = observer(() => {
  const { enrollmentCoreData, checklistOptions, enrollmentProposalData, isLoading } = useChecklistPageStore();

  return (
    <OptionList
      enrollmentPeriodId={enrollmentCoreData?.id}
      enrollmentStage={enrollmentCoreData?.stage}
      groupId={enrollmentCoreData?.groupId}
      cartId={enrollmentProposalData?.confirmedProposal?.cartId}
      options={checklistOptions}
      isLoading={isLoading}
    />
  );
});

const ChecklistPage: React.FC = () => {
  const pageStore = useMemo(() => new ChecklistPageStore(), []);
  return (
    <ChecklistPageStoreContext.Provider value={pageStore}>
      <ProposalStatusLayout>
        <PageWrapper>
          <PageHeader />
          <PageBody />
        </PageWrapper>
      </ProposalStatusLayout>
    </ChecklistPageStoreContext.Provider>
  );
};

export default ChecklistPage;
